import { auth } from './auth';
import { documents } from './documents';
import { payments } from './payments';

export const core = {
  namespaced: true,
  modules: {
    auth,
    documents,
    payments
  }
};
